import React from "react";

import { XboxSpinner } from "@gamedev-web/gamedev-sdk-core";

import * as styles from "./PageLoadingSpinner.module.css";

/** Page-level loading spinner, vertically and horizontally centered within the page content area. */
export const PageLoadingSpinner = () => (
  <div className={styles.pageLoading}>
    <XboxSpinner />
  </div>
);
